var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportCsvArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7847 26.8069L22.1859 26.1839C21.9387 25.9267 21.9382 25.5101 22.1849 25.2523L26.2531 20.9999L22.1846 16.7476C21.9382 16.4899 21.9384 16.0733 22.1856 15.8161L22.7845 15.1931C23.0319 14.9356 23.4334 14.9356 23.6809 15.1931L28.8144 20.5335C29.0619 20.791 29.0619 21.2087 28.8144 21.4662L23.6812 26.8069C23.4337 27.0644 23.0322 27.0644 22.7847 26.8069Z",
    fill: "#5964FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7847 26.8069L14.1859 26.1839C13.9387 25.9267 13.9382 25.5101 14.1849 25.2523L18.2531 20.9999L14.1846 16.7476C13.9382 16.4899 13.9384 16.0733 14.1856 15.8161L14.7845 15.1931C15.0319 14.9356 15.4334 14.9356 15.6809 15.1931L20.8144 20.5335C21.0619 20.791 21.0619 21.2087 20.8144 21.4662L15.6812 26.8069C15.4337 27.0644 15.0322 27.0644 14.7847 26.8069Z",
    fill: "#9FABFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCsvArrow);
export default __webpack_public_path__ + "static/media/import-csv-arrow.9f2e986ad411476debcd78b123c16ca8.svg";
export { ForwardRef as ReactComponent };